// extracted by mini-css-extract-plugin
export default {"privatizeContent":"privatizeContent__Rqtu6","privatize":"privatize__N1GEZ","switchInput":"switchInput__UYbwo","switch":"switch__11BM0","slider":"slider__VYy2S","round":"round__3e0Bz","privatizeWarning":"privatizeWarning__PsK7n"};
    if(module.hot) {
      // 1788784386839
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  